<template>
  <div class="schedule-container">
    <form id="filter__form form" class="filter__form form" >
        <div class="filter-container">
          <select class="filter-new" id="filter-education-level" @change="onChangeSelected($event)" v-model="selectOptionLevel">
              <option :value="null" disabled selected>Форма обучения и институт</option>
              <option value="1">Очная. ИМТ</option>
              <option value="2">Очная. ИПТО</option>
              <option value="3">Очно-заочная. ИМТ</option>
              <option value="4">Очно-заочная. ИПТО</option>
          </select>
        </div>
      </form>
    <div class="table-wrapper">
      <table class="schedule-table">
        <thead>
          <tr>
            <th rowspan="2" class="sticky-col first-col header-cell">Дни нед.</th>
            <th rowspan="2" class="sticky-col second-col header-cell">Время</th>
            <template v-for="group in listImtOtchGroup">
              <th :key="'g-' + group.id" class="sub-header">{{ group.name }}</th>
              <th :key="'ga-' + group.id" class="sub-header aud-col">Ауд.</th>
            </template>
          </tr>
        </thead>
        
        <tbody>
          <template v-for="(day, dayIndex) in days">
            <template v-for="(timeSlot, timeIndex) in timeSlots">
              <!-- ЧЕТНАЯ НЕДЕЛЯ (row-odd) -->
              <tr :key="day + '-' + timeSlot.id + '-odd'" class="row-odd">
                <td v-if="timeIndex === 0" :rowspan="timeSlots.length * 2" class="day-cell sticky-col first-col">
                  <div class="day-text">{{ day }}</div>
                </td>
                <td :rowspan="2" class="time-cell sticky-col second-col">
                  <span class="pair-time">{{ timeSlot.time }}</span>
                </td>
                
                <template v-for="group in listImtOtchGroup">
                  <td :key="'o' + dayIndex + timeSlot.id + group.id" colspan="2" class="card-cell">
                    <div 
                      class="schedule-card" 
                      :class="{ 'is-empty': !getCardData(dayIndex, timeSlot.id, group.id, 'odd').subject }"
                      @click="onCardClick(dayIndex, timeSlot.id, group.id, 'odd')"
                    >
                      <template v-if="getCardData(dayIndex, timeSlot.id, group.id, 'odd').subject">
                        <div class="card-subject">{{ getCardData(dayIndex, timeSlot.id, group.id, 'odd').subject }}</div>
                        <div class="card-room">каб. {{ getCardData(dayIndex, timeSlot.id, group.id, 'odd').room || '—' }}</div>
                      </template>
                      <template v-else>
                        <div class="card-placeholder">+ Добавить занятие</div>
                      </template>
                    </div>
                  </td>
                </template>
              </tr>
              
              <!-- НЕЧЕТНАЯ НЕДЕЛЯ (row-even) -->
              <tr :key="day + '-' + timeSlot.id + '-even'" class="row-even">
                <template v-for="group in listImtOtchGroup">
                  <td :key="'e' + dayIndex + timeSlot.id + group.id" colspan="2" class="card-cell">
                    <div 
                      class="schedule-card" 
                      :class="{ 'is-empty': !getCardData(dayIndex, timeSlot.id, group.id, 'even').subject }"
                      @click="onCardClick(dayIndex, timeSlot.id, group.id, 'even')"
                    >
                      <template v-if="getCardData(dayIndex, timeSlot.id, group.id, 'even').subject">
                        <div class="card-subject">{{ getCardData(dayIndex, timeSlot.id, group.id, 'even').subject }}</div>
                        <div class="card-room">каб. {{ getCardData(dayIndex, timeSlot.id, group.id, 'even').room || '—' }}</div>
                      </template>
                      <template v-else>
                        <div class="card-placeholder">+ Добавить занятие</div>
                      </template>
                    </div>
                  </td>
                </template>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <!-- Боковое окно справа (Sidebar Drawer) -->
    <transition name="drawer-fade">
      <div v-if="isDrawerOpen" class="drawer-overlay" @click.self="closeDrawer">
        <div class="drawer-content">
          <div class="drawer-header">
            <h3>{{ isNewLesson ? 'Создать занятие' : 'Информация о занятии' }}</h3>
            <button class="btn-close" @click="closeDrawer">&times;</button>
          </div>

          <div class="drawer-body">
            <!-- Мета-информация (только чтение) -->
            <div class="meta-info">
              <p><strong>День:</strong> {{ days[activeKeyParts.dayIndex] }}</p>
              <p><strong>Время:</strong> {{ timeSlots.find(s => s.id === activeKeyParts.timeSlotId)?.time }}</p>
              <p><strong>Группа:</strong> {{ listImtOtchGroup.find(g => g.id === activeKeyParts.groupId)?.name }}</p>
              <p><strong>Неделя:</strong> {{ activeKeyParts.weekType === 'odd' ? 'Четная' : 'Нечетная' }}</p>
            </div>

            <!-- Форма редактирования / создания -->
            <form @submit.prevent="saveLesson" class="drawer-form">
              <div class="form-group">
                <label for="drawer-subject">Название предмета *</label>
                <input 
                  type="text" 
                  id="drawer-subject" 
                  v-model="editableCard.subject" 
                  placeholder="Введите предмет" 
                  required
                />
              </div>

              <div class="form-group">
                <label for="drawer-room">Аудитория / Кабинет</label>
                <input 
                  type="text" 
                  id="drawer-room" 
                  v-model="editableCard.room" 
                  placeholder="Например, 402"
                />
              </div>

              <div class="form-group">
                <label for="drawer-teacher">Преподаватель</label>
                <input 
                  type="text" 
                  id="drawer-teacher" 
                  v-model="editableCard.teacher" 
                  placeholder="ФИО Преподавателя"
                />
              </div>

              <div class="drawer-actions">
                <button type="button" class="btn-secondary" @click="closeDrawer">Отмена</button>
                <button type="submit" class="btn-primary">
                  {{ isNewLesson ? 'Создать' : 'Сохранить изменения' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  name: "ScheduleCalendar",
  data() {
    return {
      days: ["понедельник", "вторник", "среда", "четверг", "пятница", "суббота", "воскресенье"],
      timeSlots: [
        { id: "p1", time: "08:30-09:55" },
        { id: "p2", time: "10:05-11:30" },
        { id: "p3", time: "11:40-13:05" },
        { id: "p4", time: "13:45-15:10" },
        { id: "p5", time: "15:20-16:45" },
        { id: "p6", time: "16:55-18:20" },
        { id: "p7", time: "18:30-20:00" },
        { id: "p8", time: "20:10-21:40" }
      ],
      selectOptionLevel: null,
      localScheduleState: {},

      // Сюда выносим базовую структуру расписания, чтобы Vue не пересчитывал её на каждый ввод текста
      baseScheduleStructure: {},

      // Состояния для бокового окна
      isDrawerOpen: false,
      isNewLesson: false,
      activeKey: '', 
      activeKeyParts: { dayIndex: 0, timeSlotId: '', groupId: '', weekType: '' },
      editableCard: {
        subject: '',
        room: '',
        teacher: ''
      }
    };
  },
  computed: {
    ...mapState(['selectedInstitut', 'semestrimtoch']),
    ...mapGetters(['semestrImtOchGroups', 'semestrDataGroup']),
    listImtOtchGroup() {
      let array = [];
      this.semestrImtOchGroups?.filter(v => {
        array.push({ id: 'g' + array.length, name: v })
      });
      return array;
    }
  },
  watch: {
    // Если группы загружаются асинхронно, пересобираем структуру при их изменении
    listImtOtchGroup: {
      handler(newGroups) {
        if (newGroups && newGroups.length > 0) {
          this.initScheduleStructure();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['set']),
    onChangeSelected(e) {
      this.set({ selectedInstitut: e.target.value })
      console.log(e.target.value)
    },

    // Генерируем структуру ОДИН раз, а не при каждом вводе буквы
    initScheduleStructure() {
      // 1. Создаем пустую заготовку в вашем исходном формате (Дни -> Слоты -> Группы)
      const data = {};
      this.days.forEach((day, dIdx) => {
        data[dIdx] = {};
        this.timeSlots.forEach(slot => {
          data[dIdx][slot.id] = {};
          this.listImtOtchGroup?.forEach(group => {
            data[dIdx][slot.id][group.id] = {
              odd: { subject: "", room: "", teacher: "" },
              even: { subject: "", room: "", teacher: "" }
            };
          });
        });
      });

      // 2. Создаем быстрые карты для поиска индексов в памяти за O(1)
      const dayToIndexMap = {};
      this.days.forEach((day, idx) => { dayToIndexMap[day] = idx; });

      const timeToSlotIdMap = {};
      this.timeSlots.forEach(slot => { timeToSlotIdMap[slot.time] = slot.id; });

      // Кэшируем индексы колонок для каждой группы заранее, чтобы не вызывать indexOf в цикле
      const groupMetaList = this.listImtOtchGroup?.map(group => {
        return {
          id: group.id,
          index: this.semestrimtoch?.[4]?.indexOf(group.name) // Поиск индекса в 4-й строке заголовков
        };
      }).filter(g => g.index !== undefined && g.index !== -1) || [];

      // 3. Линейный обход массива данных с сервера (ОДИН раз сверху вниз)
      let cday = '';
      let ctime = '';

      for (let i = 5; i < this.semestrimtoch.length; i++) {
        const row = this.semestrimtoch[i];
        if (!row) continue;

        // Если в строке заполнены день или время — обновляем текущие маркеры
        if (row[0]) cday = row[0];
        if (row[1]) ctime = row[1];
        

        // Мгновенно находим координаты ячейки в структуре за O(1)
        const dIdx = dayToIndexMap[cday];
        const slotId = timeToSlotIdMap[ctime];
        //console.log(dIdx, slotId)
        // Если текущий день или время отсутствуют в наших справочниках, пропускаем строку
        if (dIdx === undefined || !slotId) continue;

        const isUpWeek = i % 2 > 0;
        const weekType = isUpWeek ? 'odd' : 'even';

        // Проверяем каждую группу для этой строки
        groupMetaList.forEach(group => { 
          const description = row[group.index]; //console.log(cellValue)
          const room = row[group.index+1]
          if (description) {
            // Прямая запись в нужный узел вашей исходной структуры
            data[dIdx][slotId][group.id][weekType] = {
              subject: description,
              room: room,   // Согласно вашей логике: room = ctime
              teacher: [cday]  // Согласно вашей логике: teacher = cday
            };
          }
        });
      }
      console.log(data)
      this.baseScheduleStructure = Object.freeze(data);
    },

    getCardData(dayIndex, timeSlotId, groupId, weekType) {
      const key = `${dayIndex}-${timeSlotId}-${groupId}-${weekType}`;
      // Сначала смотрим локальные изменения пользователя
      if (this.localScheduleState[key]) {
        return this.localScheduleState[key];
      }
      // Если их нет, берем статичную базовую структуру без вызова тяжелых computed-вычислений
      const defaultData = this.baseScheduleStructure[dayIndex]?.[timeSlotId]?.[groupId]?.[weekType];

      return defaultData ? { ...defaultData } : { subject: "", room: "", teacher: "" };
    },

    onCardClick(dayIndex, timeSlotId, groupId, weekType) {
      this.activeKey = `${dayIndex}-${timeSlotId}-${groupId}-${weekType}`;
      this.activeKeyParts = { dayIndex, timeSlotId, groupId, weekType };
      
      const currentData = this.getCardData(dayIndex, timeSlotId, groupId, weekType);
      this.isNewLesson = !currentData.subject;

      this.editableCard = {
        subject: currentData.subject || '',
        room: currentData.room || '',
        teacher: currentData.teacher || ''
      };

      this.isDrawerOpen = true;
      console.log('Откр', dayIndex, timeSlotId, groupId, weekType)
    },

    closeDrawer() {
      this.isDrawerOpen = false;
    },

    saveLesson() {
      this.$set(this.localScheduleState, this.activeKey, {
        subject: this.editableCard.subject,
        room: this.editableCard.room,
        box: this.editableCard.room,
        teacher: this.editableCard.teacher
      });
      //console.log('Сохр ',dayIndex, timeSlotId, groupId, weekType)
      this.closeDrawer();
    }
  }
}
</script>

<style scoped>
.schedule-container {
  flex: 1 0 auto; /* Позволяет контенту расти и не дает футеру его перекрывать */
  font-family: 'Segoe UI', system-ui, sans-serif;
  padding: 20px;
  background-color: #f8fafc;
  color: #0f172a;
}

.schedule-title {
  text-align: center;
  margin-bottom: 24px;
}

.table-wrapper {
  overflow: auto;
  max-width: 100%;
  max-height: 70vh; /* Ограничение высоты для фиксации шапки */
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.schedule-table {
  width: 100%;
  border-collapse: separate; /* Изменено на separate для корректного border у sticky элементов */
  border-spacing: 0;
  background: white;
  font-size: 0.9rem;
}

th, td {
  border: 1px solid #cbd5e1;
  padding: 6px;
  vertical-align: middle;
}

.sticky-col {
  position: sticky;
  z-index: 2;               
  background-color: #f8fafc; 
}

/* Фиксация строк шапки table header */
thead th {
  position: sticky;
  top: 0;
  z-index: 10; /* Повышенный z-index, чтобы контент не перекрывал шапку */
  background-color: #f1f5f9;
  color: #334155;
  font-weight: 600;
  text-align: center;
}

/* Для второй строки в thead задаем смещение top */
thead tr:nth-child(2) th {
  top: 35px; /* Высота первой строки шапки, отрегулируйте под ваш шрифт */
  z-index: 10;
}

.group-header {
  background-color: #e2e8f0;
}

.week-label-header {
  font-size: 0.8rem;
  color: #64748b;
  min-width: 40px;
}

.sticky-col {
  position: sticky;
  background: #fff;
  z-index: 1;
  
}
thead th.sticky-col {
  z-index: 15;
}
.first-col {
  left: 0;
  min-width: 40px;
  max-width: 40px;
  width: 40px;
}
.second-col {
  left: 40px;
  min-width: 93px;
  max-width: 93px;
  width: 93px;
  
}
.third-col {
  left: 200px;
  min-width: 45px;
  max-width: 45px;
  width: 45px;
  text-align: center;
  border-right: 1px solid #94a3b8;
}
.first-header { left: 0; min-width: 20px; text-align: center; font-weight: bold;}
.second-header { left: 20px; min-width: 150px; text-align: center; }
thead tr:first-child th.sticky-col { z-index: 3; }
thead tr:last-child th.sticky-col { z-index: 18; }
.header-cell {
  background-color: #e2e8f0;border-right: 1px solid #94a3b8;
}
.day-cell {
  background-color: #f8fafc;
  border-right: 2px solid #94a3b8;
}

.day-text {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  padding: 10px 0;
  margin: 0 auto;color: #334155;
  font-weight: 600;
}

.time-cell {
  background-color: #f8fafc;
  border-right: 2px solid #94a3b8;
}

.pair-num {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 600;
}

.pair-time {
  font-size: 0.85rem;
}

.week-indicator-cell {
  text-align: center;
  font-weight: bold;
  color: #94a3b8;
  background-color: #f8fafc;
  font-size: 0.85rem;
}

.row-odd {
  background-color: #ffffff;
}

.row-even {
  background-color: #fdfdfd;
}

.row-even td {
  border-bottom: 2px solid #cbd5e1;
}

.input-cell {
  min-width: 445px;
  padding: 4px;
}

.aud-col {
  min-width: 10px;
  max-width: 10px;
}

.aud-col input {
  text-align: center;
}

.input-cell input {
  width: 100%;
  height: 16px;
  border: 1px solid transparent;
  padding: 4px 8px;
  font-size: 0.85rem;
  background: transparent;
  box-sizing: border-box;
  outline: none;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.input-cell input:hover {
  background-color: #f1f5f9;
}

.input-cell input:focus {
  border-color: #3b82f6;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

tbody tr:hover td:not(.day-cell):not(.time-cell) {
  background-color: #f1f5f9;
}

.card-cell {
  padding: 6px;
  /* Суммируем ширину старых колонок (445px + 54px) */
  min-width: 500px; 
  vertical-align: stretch; /* Чтобы карточка растягивалась по высоте */
}

/* Интерактивная карточка */
.schedule-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #3b82f6; /* Синяя полоска слева для красоты */
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  min-height: 50px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Эффекты при наведении и клике */
.schedule-card:hover {
  border-color: #3b82f6;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  background-color: #f8fafc;
}

.schedule-card:active {
  transform: translateY(0);
}

/* Стили текста внутри карточки */
.card-subject {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1e293b;
}

.card-room {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 500;
}

/* Состояние, когда карточка пустая */
.schedule-card.is-empty {
  border: 1px dashed #cbd5e1;
  background-color: #f8fafc;
  justify-content: center;
  align-items: center;
}

.schedule-card.is-empty:hover {
  border-color: #94a3b8;
  background-color: #f1f5f9;
}

.card-placeholder {
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 500;
}
/* НОВЫЕ СТИЛИ ДЛЯ БОКОВОГО ОКНА (DRAWER) */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.4); /* затемнение фона */
  backdrop-filter: blur(2px);z-index: 999; /* Поверх всей таблицы и шапок */
  display: flex;
  justify-content: flex-end;
}

.drawer-content {
  width: 100%;
  max-width: 450px;
  height: 100%;
  background-color: #ffffff;
  box-shadow: -4px 0 25px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
  margin-bottom: 20px;
}
  
.drawer-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #1e293b;
}

.btn-close {
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  padding: 0;
}

.btn-close:hover {
  color: #0f172a;
}

.drawer-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
}

.meta-info {
  background-color: #f1f5f9;
  padding: 14px;
  border-radius: 6px;
  font-size: 0.85rem;
  color: #475569;
}

.meta-info p {
  margin: 4px 0;
}

.drawer-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.form-group input {
  padding: 10px 12px;
  font-size: 0.9rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.15s ease;
}

.form-group input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.drawer-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.btn-primary, .btn-secondary {
  flex: 1;
  padding: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border: none;
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background-color: #2563eb;
}

.btn-secondary {
  background-color: #f1f5f9;
  color: #475569;
}

.btn-secondary:hover {
  background-color: #e2e8f0;
}
/* Анимация плавного появления оверлея и выезда шторки справа */
.drawer-fade-enter-active, .drawer-fade-leave-active {
  transition: all 0.3s ease;
}

.drawer-fade-enter, .drawer-fade-leave-to {
  opacity: 0;
}

.drawer-fade-enter .drawer-content,.drawer-fade-leave-to .drawer-content {
  transform: translateX(100%);
}

.drawer-content {
  transition: transform 0.3s ease;
}
</style>